import { Component, EventEmitter, Inject, NgZone, OnInit, Output, PLATFORM_ID, TemplateRef, ViewChild } from '@angular/core';
import { RootService } from 'src/app/shared/services/root.service';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { RegexService } from 'src/app/shared/form-validation/regex.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/shared/services/apiService.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from "ngx-spinner";
import { ModalDismissReasons, NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { secureStorage } from 'src/app/shared/services/encryption/secureservice';
import { BreadcrumbComponent } from '../../shared/components/breadcrumb/breadcrumb.component'
import { FormErrorService } from '../../shared/form-validation/form-error.service';
import { SkeletonService } from 'src/app/shared/services/skeleton.service';
import { formatDate, isPlatformBrowser } from '@angular/common';
import { PaymentService } from 'src/app/shared/services/razorpaypayment/payment.service';
import { ClevertapService } from 'src/app/shared/services/clevertap/clevertap.service';
import { ThankuResponse } from 'src/app/shared/payload-Model/billingFormModel';
import { environment } from '../../../environments/environment';
import { CommonService } from 'src/app/shared/services/common.service';
import { BehaviourSubjectService } from 'src/app/shared/services/behaviour-subject.service';
import { data } from 'jquery';

declare var $;

function _window(): any {
  // return the global native browser window object
  return window;
}

@Component({
  selector: 'app-tataok-fni-journey',
  templateUrl: './tataok-fni-journey.component.html',
  styleUrls: ['./tataok-fni-journey.component.scss']
})
export class TataokFniJourneyComponent implements OnInit {


  @ViewChild(BreadcrumbComponent) breadCrumb: BreadcrumbComponent;
  userData: any;
  breadcrumbData: any = [];
  page: any;
  sub: Subscription = new Subscription
  bookingData: any;

  environment1 = environment.s3bucket.url;
  showBookingList: boolean = true;
  heartUrls = {
    empty: "assets/images/Star-unfilled.svg",
    half: "assets/images/Star-unfilled.svg",
    full: "assets/images/Star-filled.svg"
  };
  defaultImage: string = '../../../assets/images/default_image.jpg';
  bookingDataDeatail: any;
  paymentTypeForm: FormGroup;
  VasAmount: any;
  dealerInfo: any;
  sub_lob: any;
  model: any;
  rating: any = 0;
  descriptionReview: any;
  currentLeadData: any;
  dealerData: any;
  reviewData: any = [];
  testDriveData: any = [];
  orderDetailsIndex: any;
  closeResult1: any;

  maximumSize:any=6;
  

  productReviewData: any;
itemsPerPage: any = 10;
  currentPage: any = 1;
  currentPageBooking: any = 1;
  totalItemsTD: any = 0;
  totalItemsBooking: any = 0
  productDetailList: any;
  itemsperpageconfigurator: any = 9;
  showRetryPopup: boolean = false;
  status: any = "upcoming"
  breadcrumbdata: any = [];
  @ViewChild("trackRefModal", { read: TemplateRef, static: false }) trackRefModal: TemplateRef<any>;


  isSecure: boolean = false;
  flag: any = 'moreDetails';
  activeClass: boolean = false;
  isMobile: boolean = false;
  userAadharno:any;
  
  
  constructor(private toastrService: ToastrService, private apiService: ApiService,private secureService: RootService,private router: Router,
    private spinner: NgxSpinnerService, private modalService: NgbModal, public skeletonService: SkeletonService,
    @Inject(PLATFORM_ID) private platformId: Object,
    ) {  }
  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {

    $('.header').addClass('p-scroll');
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        this.isMobile = true;
       this.maximumSize=6

      } else {
        this.isMobile = false;
        this.maximumSize=6
      }
      this.getUserDetails()
      this.userData = this.secureService?.getUserData();

    }
       this.currentPageBooking = 1
      this.getBookingDetails({ "offset": 0*10, "limit": 10,  "lead_source":"osp" });
  }

  getUserDetails() {
    if (isPlatformBrowser(this.platformId)) {
    let res = this.secureService.isLoggedIn();
    if (res) {
      this.sub.add(this.apiService.getUserData().subscribe({
        next: (response: any) => {
          if (response?.data?.user_documents) {
            this.userAadharno=response?.data?.user_documents.filter((res)=>{
              return  res?.document_description == 'aadhar_card'
              })
          }
        },
        error: () => {
        },
      })
      );
    }
  }
  }

  @Output() goBack: EventEmitter<void> = new EventEmitter<void>();
  
  mobileBack() {
    this.goBack.emit();
  }




  viewFlag: string = 'secure'; // or 'expandDetails'
  recordId: number = 1;
  activeRecordId: number | null = null;

  calculateTotalAmount(data: any): number {
    return data.total_booking_amount || 0;
  }


  toggleDetails(requestId: string, recordId: number, flag: string): void {
    this.viewFlag = flag;
    this.activeRecordId = this.activeRecordId === recordId ? null : recordId;
  }

  fetchVehicleData(data: any): void {
    console.log('Fetching vehicle details:', data.vehicle_specs);
  }

  fetchDealerInfo(vehicleSpecs: any, divisionCode: number, flag: string, recordId: number): void {
    console.log('Fetching dealer info for:', vehicleSpecs, divisionCode);
  }

  fetchLeadStatus(requestId: string, recordId: number): void {
    console.log('Fetching lead status for:', requestId);
  }

  fetchReviewStatus(vehicleSpecs: any, divisionCode: number, vehicleCode: string, recordId: number): void {
    console.log('Fetching review status for:', vehicleSpecs, divisionCode, vehicleCode);
  }

  getBookingDetails(reqBody: any) {
    if (isPlatformBrowser(this.platformId)) {
      try {
        this.spinner.show();
        this.breadcrumbData = ['account', 'bookings'];
  
        this.sub.add(this.apiService.getusedvehiclesLead(reqBody).subscribe({
          next: (response: any) => {
 
            if (response?.success === true && response?.data?.length > 0) {
              this.bookingData = response.data;
              this.totalItemsBooking = response?.total_count || 0;
            } else {
              // Show the empty state if no bookings or invalid response
              this.bookingData = [];
              this.totalItemsBooking = 0;
              this.toastrService.warning(response?.data?.msg || 'No data available');
            }
          },
          error: (err) => {

            this.spinner.hide();
            this.bookingData = [];
            // this.toastrService.warning('Something went wrong!');
          },
          complete: () => {
            this.spinner.hide();
          }
        }));
      } catch (error) {
        this.spinner.hide();
     
      }
    }
  }



  getStageDate(stage: string, leadStagesHistory: any[]): string | null {
    const stageItem = leadStagesHistory.find(item => item.lead_new_stage === stage);
    return stageItem ? stageItem.created_at : null;
  }
  
  isStageReached(stage: string, leadStagesHistory: any[]): boolean {
    return leadStagesHistory.some(item => item.lead_new_stage === stage);
  }
  
  
  pageChangeBooking(page: any) {
    this.currentPageBooking = page;
    this.orderDetailsIndex = null
    page = page - 1;
    let reqBody =
    {
      "offset": page * 10,
      "limit": 10,
      "lead_source":"osp"
    };
    this.getBookingDetails(reqBody);
  }


  moreDetails(row_id: any, index: any, flag) {

    this.flag = flag;
    if (this.orderDetailsIndex == index) {
      if (this.isSecure && flag == 'moreDetails') {
        this.showBookingList = false;
      } else if (!this.isSecure && flag == 'secure') {
        this.showBookingList = false;
      }
      else {
        this.orderDetailsIndex = null;
        this.showBookingList = true;
      }

      this.isSecure = flag != 'moreDetails' ? true : false
    } else {
      this.orderDetailsIndex = index;
      this.showBookingList = false;
      this.isSecure = flag != 'moreDetails' ? true : false

    }
  }
  redirect(data) {
    var currentUrl = '/buy-used-vehicles-productdetail/' +  data;
    return currentUrl;

  }
  numSequence(n: number): Array<number> {
    return Array(n);
  }
  

  setDefaultImage(event: Event) {
    (event.target as HTMLImageElement).src = this.defaultImage;
  }

  goTo(){
    this.router.navigate(['/buy-used-vehicles/'])
  }
}
